export default () => jQuery(($) => {
	$(document.activeElement).click(function (e) {
		$('.horizontalNav button.dropdown__title').each(function (idx, elem) {
			if ($(elem).hasClass('FOCUSED')) {
				$(elem).removeClass('FOCUSED');
				$(elem).blur();
			} else if ($(elem)[0] === $(e.target)[0]) {
				$(elem).addClass('FOCUSED');

				// detect edge
				var menuElement = $(elem).siblings('.dropdown__menu');
				var menuOffset = menuElement.offset();
				var menuLeft = menuOffset.left;
				var menuWidth = menuElement.width();
				var docWidth = $('.horizontalNav').parent().width();

				var isEntirelyVisible = (menuLeft + menuWidth <= docWidth);
				if (!isEntirelyVisible) {
					menuElement.addClass('edgeDetection');
				}
			}
		});
	});
	$(window).resize(function () {
		$('.dropdown__menu').removeClass('edgeDetection');
	});
});
